import { makeStyles } from "@material-ui/core";

export default makeStyles(({ spacing, palette }) => ({
  approvalActionButton: {
    marginRight: spacing(3),
    padding: `${spacing(1)}px ${spacing(2)}px`,
  },
  buttonSecondary: {
    color: palette.error.main,
  },
  revisionButton: {
    marginLeft: spacing(3),
  },
}));
